import React, { useState, useEffect } from 'react';
import PlacesAutocomplete, { geocodeByAddress, geocodeByPlaceId } from 'react-places-autocomplete';
import LinearProgress from '@mui/material/LinearProgress';
import { Input, IconGraphy, Typography } from '@leapeasy/ui-kit';

export default function GoogleMaps({ handleAddress, handleStreet, address1 }) {
  const [address, setAddress] = useState(null);

  useEffect(() => {
    setAddress(address1);
  }, [address1]);

  const handleSelect = async (address, placeId) => {
    const [place] = await geocodeByPlaceId(placeId);
    handleAddress(place);
  };

  const handleChage = (address) => {
    setAddress(address);
    handleStreet(address);
  };

  return (
    <div className="inputLine">
      <PlacesAutocomplete value={address} onChange={handleChage} onSelect={handleSelect}>
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div className="inputFielders">
            <div className="fieldLine">
              <Input
                {...getInputProps({ placeholder: 'Address Line 1', className: 'inputField' })}
                label="Street"
                type="text"
                icon={<IconGraphy icon="MapTravel.EditLocationAlt" />}
                minWidth="100%"
                size="medium"
                fullWidth
                showCopy={false}
                showHelperMessage={false}
              />
            </div>
            <div>
              {loading ? (
                <div>
                  <LinearProgress color="primary" />
                </div>
              ) : null}
              <div className="suggestionDrop">
                {suggestions.map((suggestion) => {
                  const style = {
                    backgroundColor: suggestion.active ? '#70247247' : '#ede8ed',
                    cursor: suggestion.active ? 'pointer' : 'default',
                    padding: '0px 8px',
                  };
                  return (
                    <Typography variant="body1" {...getSuggestionItemProps(suggestion, { style })}>
                      {suggestion.description}
                    </Typography>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    </div>
  );
}
